export default /* glsl */`
  varying vec2 vUv;
  uniform sampler2D uTexture;
  uniform vec3 uTranslate;
  uniform float bendingRadius;

  void main(){
    vec3 transformed = position;
    transformed += uTranslate;

    float radian = transformed.x;
    radian /= bendingRadius;

    transformed = vec3(bendingRadius * sin(radian), transformed.y, transformed.z + bendingRadius * cos(radian));
    // transformed = vec3(transformed.x, transformed.y, transformed.z + bendingRadius);

    gl_Position = projectionMatrix * modelViewMatrix * vec4(transformed,1.);
    vUv = uv;
  }
`;
